import React, { Suspense } from "react";
import { CreditsModal } from "./CreditsModal";
import { AdministrationUtilities } from "../../administration/AdministrationHelper";
import Dict from "dict-lib";

export class Credits extends React.Component {

    constructor(props) {
        super(props);

        const installationInd = AdministrationUtilities.getInstallationId();

        this.state = {
            CustomCredits: null,
            loaded: false
        };

        this.modalRef = React.createRef();

        // Tentativo di import dinamico con fallback
        import(`../../_custom-layout/${installationInd}/Credits.js`)
            .then(module => {
                this.setState({
                    CustomCredits: React.lazy(() => Promise.resolve({ default: module.default })),
                    loaded: true
                });
            })
            .catch(() => {
                // Nessun Credits custom → non mostrare nulla
                this.setState({
                    CustomCredits: null,
                    loaded: true
                });
            });
    }

    render() {
        const { CustomCredits, loaded } = this.state;

        if (!loaded) return null;

        return (
            <>
                {CustomCredits && (
                    <Suspense fallback={null}>
                        <CustomCredits
                            onOpenModal={(bodyName, title) => this.modalRef.current._open(bodyName, title)}
                        />
                    </Suspense>
                )}

                <CreditsModal
                    ref={this.modalRef}
                />
            </>
        );
    }
}